import Search from "../../search/Search";
import SearchApi from "../../../api/SearchApi";

const getCleanKeywords = keywords => {
    return keywords.replace(/[\[\]']/g, "").split(',')
};

const Keywords = () => {
    return (
        <Search
            type={'keywords'} 
            api={SearchApi.searchPlaceRepresentKeywords}
            useKeyword={false} 
            targetPlaceholder={'m.place.naver.com/place/로 시작하는 플레이스 주소입력'}
            headers={['업체명', '대표 키워드']}
            dataIdx={[4, 6]}
            dataManupulator={data => {
                return getCleanKeywords(data).map(k => (
                    <>{k}<br/></>
                ))
            }} 
        />
    );
}

export default Keywords;
